/** Match statuses from here https://github.com/Snagajob/Lib.SAJ.CoreStandard/blob/a2b0029a0017f57a7e4ca9169112da915d35de95/Lib.SAJ.CoreStandard/Enums/CandidateAggregationStatus.cs#L3 */
export enum CandidateAggregationStatus {
  ['Needs review'] = 1,
  Reviewed = 2,
  Hired = 3,
  Declined = 11,
  Contacted = 15,
}
